module.exports = __webpack_public_path__ + "img/lv4_3_1.8c98ee80.png";